// src/components/SimpleComponents/SimpleRangePicker.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { DatePicker } from 'antd';
import SimpleFormItem from './SimpleFormItem';
import { getDateFormatByLocale } from 'utils/helpers';
import useFormElement from 'hooks/useFormElement';
import { useSimpleFormContext } from './SimpleFormProvider';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const SimpleRangePicker = ({
  name,
  subdocumentField,
  format = getDateFormatByLocale(),
  showTime = false,
  className = '',
  disabled,
  ...props
}) => {
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  const { locked, disabledFields } = useSimpleFormContext();

  // 2. HOOKS & REFS
  const elementProps = useFormElement(name, subdocumentField);
  const { elementRef, fullFieldName, flattenFieldName } = elementProps;

  // 3. LOCAL VARIABLES I
  const isDisabled = disabled || locked || disabledFields?.includes(flattenFieldName);

  // 8. UI
  return (
    <SimpleFormItem {...props} name={fullFieldName} elementProps={elementProps} isDatePicker={true}>
      <DatePicker.RangePicker
        ref={elementRef}
        id={flattenFieldName}
        className={`w-100 no-border-radius ${className}`}
        format={format}
        showTime={showTime}
        disabled={isDisabled}
        allowEmpty={[true, true]}
      />
    </SimpleFormItem>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default SimpleRangePicker;
